<template>
    <div class="modal modal-info modal-info-2 fade" :id="modalId" tabindex="-1" role="dialog" :aria-labelledby="modalId"
         aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4>Select color for the Calendar</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    </button>
                </div>
                <div class="modal-body">
                    <div class="modal-inner">
                        <div class="row justify-content-center">
                            <div class="col-10">
                                <div class="calendar-color">
                                    <div
                                        class="form-group form-group-4"
                                        v-for="color in colors"
                                        :key="color.id"
                                    >
                                        <div
                                            class="form-check"
                                            :class="'form-check-c' + (color.id)"
                                        >
                                            <input
                                                class="form-check-input-checkbox"
                                                type="radio" id="home-office"
                                                v-model="selectedColor"
                                                :value="color"
                                            >
                                            <label class="form-check-label" for="home-office"></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="btns-wrap">
                            <button
                                class="btn btn--outline-primary"
                                @click="closeModal(modalId)"
                            >Cancel
                            </button>
                            <button
                                class="btn btn--secondary"
                                @click="updateColor"
                            >Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import StyleHandler from "../../../../../resources/js/mixins/StyleHandler";
import ModalHandler from "../../../../../resources/js/mixins/ModalHandler";

export default {
    name: 'EventColorModal',
    mixins: [ StyleHandler, ModalHandler],
    props: {
        confirmText: String,
        modalId: {
            type: String,
            required: true,
        },
        rejectText: String,
    },
    data() {
        return {
            selectedColor: null,
        }
    },
    emits: ['update-color'],
    methods: {
        updateColor() {
            this.closeModal(this.modalId)
            this.$emit('update-color', this.selectedColor);
        }
    },
    mounted() {
        console.log(this.modalId)
    }
}

</script>

<style scoped>

</style>
